import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "services";
import http from "services/httpService";
import useSWR from "swr";

function VerificationAlert() {
  const url = `${BASE_URL}/users/who_i_am`;
  const fetcher = async () => {
    const res = await http.get(url);
    return res?.data?.data;
  };

  const { data: user } = useSWR(url, fetcher);

  if(!user) return null
  if(user?.nin_verified && user?.nin) return null

  return (
    <section className="pb-8">
      <div className="p-4 rounded-lg border border-solid border-primary-300 relative bg-primary-100">
        <p className="font-poppins text-primary text-base font-semibold capitalize">
          NIN Verification Now Required
        </p>
        <p className="font-poppins text-primary text-sm">
          Due to a recent update, you’ll need to verify your NIN before
          submitting new loan applications. To continue, please complete your
          verification from your profile settings.
        </p>
        <div className="flex justify-start gap-x-4 mt-3">
          <Link to="/dashboard/profile/verify-nin">
            <button className="text-sm flex items-center text-primary-800 border border-solid border-primary-300 p-3 py-2 rounded-lg bg-white font-semibold">
              <span className="pr-2">Complete Verification</span>
              <i className="bi bi-arrow-right text-base"></i>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default observer(VerificationAlert);
